import { Box } from '@chakra-ui/react';
import { useIsWiderThan940px } from '@duke-hq/ui/components/hooks/useIsWiderThan940px';

import useDashboardContext from '../../context/useDashboardContext';

interface Props {
  PanelContent: React.ComponentType;
}

function SidePanel({ PanelContent }: Props) {
  const { panelProps } = useDashboardContext();

  return (
    <Box
      w="side-panel"
      h="full"
      p={3}
      flexShrink={0}
      bg="bg.subtle"
      borderLeft="1px"
      borderColor="border.default"
    >
      <PanelContent {...panelProps} />
    </Box>
  );
}

export default function ResponsiveSidePanel({ PanelContent }: Props) {
  const [isWiderThan940px] = useIsWiderThan940px();

  return isWiderThan940px ? (
    <SidePanel PanelContent={PanelContent} />
  ) : (
    <Box position="fixed" right="0" height="100%">
      <SidePanel PanelContent={PanelContent} />
    </Box>
  );
}
